export default "__VITE_ASSET__BVfRmFhL__"